import { useEffect } from 'react'

export const useDeprecated = (alternativeComponent?: string) =>
  useEffect(() => {
    const alternativeText = `, please use ${alternativeComponent} instead`
    // eslint-disable-next-line no-console
    console.warn(`This component is deprecated${alternativeComponent ? alternativeText : ''}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
